module.exports = __webpack_public_path__ + "media/images/procedure_managements/what_is/img_mobile_1-f7511d53043cca2165db89eb60152509.png";